import classNames from 'classnames';
import React from 'react';
import { Card } from 'react-bootstrap';

import styles from './styles.module.scss';

const ProductsCard: React.FC<React.BaseHTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
}) => (
  <Card
    className={classNames(
      'p-5 align-items-start font-size-lg',
      styles.card,
      className,
    )}
    style={{
      flex: 1,
    }}
  >
    {children}
  </Card>
);

export default ProductsCard;
